<script setup>
import UserWrapper from '@/components/VisionAi/UserWrapper.vue';
import { stripHtmlFromMessage } from '@/components/VisionAi/utils/message';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <UserWrapper is-text-only-button class="!w-fit" data-test="user-message">
    <span>{{ stripHtmlFromMessage(props.text) }}</span>
  </UserWrapper>
</template>
